// src/services/role.service.ts
import { privateRequest } from "../axios";

export interface Role {
  id: number;
  name: string;
  description?: string;
  createdAt?: string;
  updatedAt?: string;
}

export interface RolesResponse {
  rows: Role[];
  count: number;
}

// Generic API wrapper
export interface ApiResponse<T> {
  statusCode: number;
  success: boolean;
  message: string;
  data: T;
}

const ENDPOINTS = {
  ROLE: "/role",
  ROLE_ID: (id: number | string) => `/role/${id}`,
};

const getRoles = async (
  params?: Record<string, any>
): Promise<RolesResponse> => {
  const response = await privateRequest.get<ApiResponse<RolesResponse>>(
    ENDPOINTS.ROLE,
    { params }
  );
  return response.data.data; // 👈 unwrap correctly
};

// ✅ Get Role by ID
const getRoleById = async (id: number | string): Promise<Role> => {
  const response = await privateRequest.get<Role>(ENDPOINTS.ROLE_ID(id));
  return response.data;
};

// ✅ Add Role
const addRole = async (data: Omit<Role, "id">): Promise<Role> => {
  const response = await privateRequest.post<Role>(ENDPOINTS.ROLE, data);
  return response.data;
};

// ✅ Update Role
const updateRole = async (
  id: number | string,
  data: Partial<Role>
): Promise<Role> => {
  const response = await privateRequest.put<Role>(ENDPOINTS.ROLE_ID(id), data);
  return response.data;
};

// ✅ Delete Role
const deleteRole = async (
  id: number | string
): Promise<{ success: boolean; message?: string }> => {
  const response = await privateRequest.delete<{
    success: boolean;
    message?: string;
  }>(ENDPOINTS.ROLE_ID(id));
  return response.data;
};

const RoleService = {
  getRoles,
  getRoleById,
  addRole,
  updateRole,
  deleteRole,
};

export default RoleService;
